export class Config {
  // properties
  apiUrl: string;
  bffApiUrl: string;
  loginUrl: string;
  logoutUrl: string;
  CronofyLogin: string;
  RedirectionURL: string;
  LeadDashboardURL: string;
  accountApiUrl: string;
  WebUrl: string;
  mediaLibraryUrl: string;
  coreUrl: string;
  GtmCode: string;

  // constructor
  constructor() {
    // set default values first
    this.apiUrl = "";
    this.bffApiUrl = "";
    this.loginUrl = "";
    this.logoutUrl = "";
    this.LeadDashboardURL = "";
    this.accountApiUrl = "";
    this.WebUrl = "";
    this.mediaLibraryUrl = "";
    this.coreUrl = "";
    this.GtmCode = "";
    try {
      // try to load JSON configuration file
      var config = require("./config.json");

      // parse API section (if any)
      if (config.hasOwnProperty("api")) {
        var apiConfig = config["api"];

        // read URL (if any)
        if (apiConfig.hasOwnProperty("url")) {
          this.apiUrl = apiConfig["url"];
        }
        if (apiConfig.hasOwnProperty('accountUrl')) {
          this.accountApiUrl = apiConfig['accountUrl']
        }
      }

      // parse SSO section (if any)
      if (config.hasOwnProperty("sso")) {
        var apiConfig = config["sso"];

        // read login (if any)
        if (apiConfig.hasOwnProperty("login")) {
          this.loginUrl = apiConfig["login"];
        }
        if (apiConfig.hasOwnProperty("logout")) {
          this.logoutUrl = apiConfig["logout"];
        }
      }

      if (config.hasOwnProperty("BffApiURL")) {
        this.bffApiUrl = config["BffApiURL"];
      }

      if (config.hasOwnProperty("CronofyLogin")) {
        this.CronofyLogin = config["CronofyLogin"];
      }

      if (config.hasOwnProperty("RedirectionURL")) {
        this.RedirectionURL = config["RedirectionURL"];
      }

      if (config.hasOwnProperty("LeadDashboardURL")) {
        this.LeadDashboardURL = config["LeadDashboardURL"];
      }

      if (config.hasOwnProperty('WebUrl')) {
        this.WebUrl = config['WebUrl'];
      }

      if (config.hasOwnProperty('MediaLibraryUrl')) {
        this.mediaLibraryUrl = config['MediaLibraryUrl'];
      }
      if (config.hasOwnProperty('CoreUrl')) {
        this.coreUrl = config['CoreUrl'];
      }

      if (config.hasOwnProperty("GtmCode")) {
        this.GtmCode = config["GtmCode"];
      }

    } catch (e) {
      console.log("No config.json found - using default values");
    }
  }
}

export class FroalaConfig {
  froalaKey: string;
  constructor() {
    this.froalaKey = ''
    let froalaConfig = require('./config.json');
    if (froalaConfig.hasOwnProperty('FroalaEditorKey')) {
      this.froalaKey = froalaConfig.FroalaEditorKey;
    }
  }
}


// WEBPACK FOOTER //
// ./src/config.ts